module.exports = __webpack_public_path__ + "img/s2.b58da975.jpg";